/**
 * Test IDs for QA automation.
 */
export const testIds = {
  planningCalendar: "planning-calendar",
  planningCalendarAppointment: "planning-calendar-appointment",
  planningCalendarResourceRow: "planning-calendar-driver-row",
  planningCalendarDriveToPickup: "planning-calendar-drive-to-pickup",
  planningCalendarDriveToNextTrip: "planning-calendar-drive-to-next",
  planningCalendarClickPopoverContent: "planning-calendar-click-popover-content",
  planningCalendarHoverPopoverContent: "planning-calendar-hover-popover-content",
  planningCalendarDriverName: (driverId: string) =>
    `planning-calendar-driver-name-${driverId}`,
  planningCalendarAssignDriverToShift: "planning-calendar-assign-driver-to-shift",
  planningCalendarLinkDriverToAsset: "planning-calendar-link-driver-to-asset",
  planningCalendarRemoveDriverFromTrip: "planning-calendar-remove-driver-from-trip",
  planningCalendarSeparateTrip: "planning-calendar-separate-trip",
  planningCalendarTripAfterShiftWarning: "planning-calendar-trip-after-shift-warning",
  planningCalendarShipmentNavigation: "planning-calendar-shipment-navigation",
  planningCalendarShipmentNumber: "planning-calendar-shipment-number",
} as const;
